import React from 'react';
import { stringifyUrl } from 'query-string';
import { SocialShareUrls } from '../../../../../../constants';
import { TwitterShareIcon } from '../../../../../../wag-react/next-components/icons';
import { Button } from '../../../../../../wag-react/next-components/button';
export const TwitterShareButton = ({
  shareUrl,
  text
}) => {
  const href = stringifyUrl({
    url: SocialShareUrls.TweetButtonIntentUrl,
    query: {
      url: shareUrl,
      text
    }
  });
  return <Button href={href} data-sentry-element="Button" data-sentry-component="TwitterShareButton" data-sentry-source-file="index.tsx">
      <TwitterShareIcon data-sentry-element="TwitterShareIcon" data-sentry-source-file="index.tsx" />
    </Button>;
};